import { render, staticRenderFns } from "./CustomerTypeComponent.vue?vue&type=template&id=470c6c7a"
import script from "./CustomerTypeComponent.vue?vue&type=script&lang=ts"
export * from "./CustomerTypeComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports